export const SUCCESS = 'success'